export default {
  SUPER_ADMIN: 'super admin',
  MANAGEMENT: 'management',
  AGENT: 'agent',
  SUPERVISOR: 'supervisor',
  MANAGER: 'manager',
  API: 'api'
}
